import { Helmet } from "react-helmet-async";

import { LEGAL } from "@/pages/legal/legalDetails";

/**
 * Structured data for one page (REQ-016 AC-004).
 *
 * Emitted through Helmet, so the build-time prerender (scripts/prerender.mjs)
 * writes it into the served HTML, where crawlers that run no JavaScript find
 * it. Build the object from the same values the page displays: a fact in the
 * markup that the page does not show is what search engines penalise, and
 * assistants quote it as if it were true.
 */
export function JsonLd({ data }: { data: Record<string, unknown> }) {
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify({ "@context": "https://schema.org", ...data })}
      </script>
    </Helmet>
  );
}

export const SITE_URL = "https://travelhealthpass.app";

/** The seller, from the same record the imprint displays. */
export const ORGANIZATION = {
  "@type": "Organization",
  "@id": `${SITE_URL}/#organization`,
  name: "HealthPass",
  url: SITE_URL,
  logo: `${SITE_URL}/images/favicon-icon.svg`,
  legalName: LEGAL.operator.name,
  email: LEGAL.contact.general,
  telephone: LEGAL.operator.phone,
  address: {
    "@type": "PostalAddress",
    streetAddress: LEGAL.operator.street,
    addressLocality: LEGAL.operator.city,
    addressCountry: LEGAL.operator.country,
  },
};
